import { Pipe, PipeTransform } from '@angular/core';
import { Passenger } from '../classes/passenger';

@Pipe({
  standalone: false,
  name: 'passengerNameFormat'
})
export class PassengerNameFormatPipe implements PipeTransform {
  transform(passenger: Passenger): unknown {
    return `${passenger.firstName[0]}. ${passenger.lastName.length > 11
      ? passenger.lastName.substring(0, 8) + '...'
      : passenger.lastName}`;
  }
}
